import { SelectBox } from 'devextreme-react'
import React from 'react'
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import useFormatMessage from '../../utils/useFormatMessage'

const AlgoritmaSecimi = ({
    setAlgorithmSelected,
    algorithmSelected,
    isOpen,
    setIsOpen,
    fetchAdresler
}) => {
    const [select, setSelect] = React.useState(algorithmSelected)
    const { t } = useFormatMessage()
    return (
        <Modal size='md' isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
            <ModalHeader toggle={() => setIsOpen(!isOpen)}>

            </ModalHeader>

            <ModalBody className='p-4'>
                <Row>
                    <Col>

                        <FormGroup>
                            <Label>
                                {t("Adres Doldurma")}
                            </Label>
                            <SelectBox
                                valueExpr={"algorithm_type"}
                                displayExpr={"name"}
                                items={[
                                    { algorithm_type: 'FILL_ALL', name: 'Tamamını Doldur' },
                                    { algorithm_type: 'X_COUNT', name: 'Adet Gir' }
                                ]} value={select.algorithm_type} onValueChanged={(e) => setSelect({ ...select, algorithm_type: e.value })} />
                        </FormGroup>
                    </Col>

                    <Col>
                        {
                            select.algorithm_type === 'X_COUNT' ? (

                                <FormGroup>
                                    <Label>{t("Adet")}</Label>
                                    <Input
                                        type="number"
                                        value={select.x_count}
                                        onChange={(e) => {
                                            if (e.target.value === "") {
                                                setSelect({
                                                    ...select, x_count: null

                                                })
                                            } else if (Number(e.target.value) < 0) {
                                                setSelect({
                                                    ...select, x_count: 0

                                                })
                                            }
                                            else {
                                                setSelect({
                                                    ...select, x_count: Number(e.target.value)

                                                })
                                            }
                                        }}
                                    />
                                </FormGroup>

                            ) : null
                        }
                    </Col>
                </Row>
                <Row>
                    <Col>

                        <FormGroup>
                            <Label> {t("Başlangıç Yönü ")}</Label>

                            <SelectBox
                                valueExpr={"direction"}
                                displayExpr={"name"}
                                items={[
                                    { direction: 'START', name: 'BAŞTAN' },
                                    { direction: 'END', name: 'SONDAN' }
                                ]} value={select.direction} onValueChanged={(e) => setSelect({ ...select, direction: e.value })} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>

                        <FormGroup>
                            <Label>{t("İlerleme Yönü")}</Label>
                            <SelectBox valueExpr={"scan_type"} displayExpr={"name"} items={[
                                { scan_type: 'VERTICAL', name: 'DİKEY' },
                                { scan_type: 'HORIZONTAL', name: 'YATAY' }
                            ]} value={select.scan_type} onValueChanged={(e) => setSelect({ ...select, scan_type: e.value })} />
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>

            <ModalFooter>
                <Button onClick={() => {
                    setAlgorithmSelected(select);
                    setIsOpen(!isOpen);

                }}> <i className="fa fa-save"></i></Button>
                <Button color='danger' onClick={() => setIsOpen(!isOpen)}>
                    <i className="fa fa-times"></i>
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default AlgoritmaSecimi